import React, { useState, useEffect } from "react";
import styles from "./mob_catalog.module.css";


function MobCatalog({
  currCategories, parentCat, handleChangeCat
}) {


  const handleClick = (evt) => {
    handleChangeCat(currCategories.find(item => item.name === evt.target.innerText).id)
  }
  const handleParentClick = () => {
    console.log('click On Parent');
  }

  // console.log('currCategories =', currCategories);


  return (
    <ul className={styles.catalog}>
      {parentCat.id &&
        <li className={styles.itemLink}
          onClick={handleParentClick}
        >
          <div className={styles.arrowLeft} />
          {parentCat.name}
        </li>
      }
      {
        currCategories.map((categorie, key) => {
          return (

            <li key={key} className={styles.itemLink}
              onClick={handleClick}
            >
              {/* {categorie.parent &&
                <div className={styles.arrowLeft} />
              } */}
              {categorie.name}
              {categorie.children.length > 0 &&
                <div className={styles.arrowRight} />
              }
            </li>
          )
        })
      }
    </ul>
  );
}

export default MobCatalog;
